import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError, timer} from 'rxjs';
import {catchError, retry, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoggingService} from 'mclane-apptemplate-lib';
import { LoadingIndicatorHelper } from '../services/loading-indicator-helper';


@Injectable({
  providedIn: 'root'
})
export class RetryInterceptorService implements HttpInterceptor {

  private readonly EXCLUDED_STATUSES = [504, 406];

  constructor(public router: Router, public console: LoggingService,
              public loadingIndicator: LoadingIndicatorHelper) {
    this.console.log('RetryInterceptorService()');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const genericRetryStrategy = ({
      maxRetryAttempts = 3,
      scalingDuration = 3000,
      excludedStatusCodes = this.EXCLUDED_STATUSES
      ,
    }: {
      maxRetryAttempts?: number;
      scalingDuration?: number;
      excludedStatusCodes?: number[];
    } = {}) => {
      return (attempts: Observable<any>) =>
        attempts.pipe(
          retry({
            count: maxRetryAttempts,
            delay: (error, retryAttempt) => {
              if (excludedStatusCodes.includes(error.status)) {
                return throwError(() => error);
              }
   
              console.log(
                `Attempt ${retryAttempt}: retrying in ${scalingDuration}ms`
              );
              return timer(scalingDuration);
            },
          }),
          catchError((error) => {
            console.error('Retries exhausted. Handling error...', error);
            return throwError(() => error);
          }),
          tap({
            finalize: () => {
              console.log('Retries completed or aborted');
            },
          })
        );
    };

    return next.handle(request).pipe(
      genericRetryStrategy({
        maxRetryAttempts: 3,
        scalingDuration: 3000,
        excludedStatusCodes: this.EXCLUDED_STATUSES,
      })
    )
  }
}

